<template>
  <el-card
    v-loading="loading"
    class="clear-card myMiniSurvey"
    :class="['mobile','tablet'].includes($mq) ? 'mobile' : 'desktop'"
    shadow="hover"
    :body-style="{
      height: 'calc(100% - 95px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center'
    }"
  >
    <div
      slot="header"
      class="clearfix title header defaultCursor"
    >
      <span>{{ $t('aside.pulse') }}</span>
    </div>
    <div
      class="content"
      :class="session >= 6 && openFlag ? 'filledData' : ''"
      :style="`display: flex; width: 100%; height: 100%;
        flex-direction: column;`"
    >
      <div
        v-if="session >= 6 && openFlag"
        class="charts"
      >
        <PulseScoreLeader
          v-if="pulseData"
          :report="pulseData"
          :narrow="true"
        />
      </div>
      <template v-else>
        <span></span>
        <div class="no-data defaultCursor">
          {{ $t('pulse.reportAfterClosed') }}
        </div>
      </template>

      <span class="viewDetailsBtn">
        <el-button
          v-if="session >= 6"
          class="detailsBtn"
          round
          :loading="viewLoading"
          :disabled="session < 6"
          @click="toggleDetail"
        >
          {{ $t('settings.viewDetails') }}
        </el-button>
      </span>
    </div>

    <!--<PulseDetails
      :show.sync="showDetails"
      :leader-uuid="leaderUuid"
    />-->
  </el-card>
</template>

<script>
// import PulseDetails from './PulseDetails.vue';
import api from '@/api';

export default {
  components: {
    PulseScoreLeader: () => import(/* webpackChunkName: "Charts" */ '@/views/dashboard/content/common/welcome/widgets/charts/PulseScoreLeader.vue'),
    // PulseDetails,
  },

  props: {
    leaderUuid: {
      type: String,
      default: '',
    },

    session: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      openFlag: false,
      callFlag: false,
      pulseData: null,
      responses: {
        pulse1: null,
        pulse2: null,
      },
      loading: false,
      showDetails: false,
      viewLoading: false,
    };
  },

  computed: {
    sessionFlag() {
      return !!(this.session && this.session >= 6);
    },
  },

  watch: {
    sessionFlag(newValue) {
      if (newValue && !this.callFlag) {
        this.callFlag = false;
        this.getPulseSimpleLeader();
      }
    },
  },

  created() {
    if (this.session >= 6 && !this.callFlag) {
      this.callFlag = false;
      this.getPulseSimpleLeader();
    }
  },

  methods: {
    async getPulseSimpleLeader() {
      try {
        this.loading = true;
        let pulseData = null;
        const response = await api.getLeaderPulse(this.leaderUuid, { quick: true });
        if (response && response.data) {
          pulseData = {};
          Object.keys(response.data).forEach((pulse) => {
            const keySort = { self: 1, manager: 2, stakeholder: 3 };
            pulseData[pulse] = {};
            if (response.data[pulse]) {
              Object.keys(response.data[pulse])
                .sort((a, b) => keySort[a] - keySort[b])
                .forEach((key) => {
                  if (key === 'respondent_ct') {
                    this.responses[pulse] = response.data[pulse][key];
                  } else {
                    const newKey = key === 'stakeholder' ? 'coworkers' : key;
                    pulseData[pulse][newKey] = response.data[pulse][key];
                  }
                });
            }
          });
        }
        this.pulseData = pulseData;
        this.openFlag = true;
      } catch (err) {
        if (err.msg && !['Pulse report is currently not available', 'Report is not ready yet.']
          .includes(err.msg)) {
          this.$message.error(err.msg);
        }
        console.log(err);
      } finally {
        this.loading = false;
      }
    },

    toggleDetail() {
      this.viewLoading = true;

      // Without set-timeout, flag not working.
      setTimeout(() => {
        this.$router.push({ name: 'myLeaderPulseDetail' }).catch((err) => {});
      }, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.myMiniSurvey {
  height: 100%;
  min-height: 154px;

  &:not(.mobile):not(.tablet) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &.mobile,
  &.tablet {
    .el-card__header {
      border-bottom: 0;
    }
  }

  .nbRespondent {
    display: flex;
    flex-wrap: wrap;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    color: var(--themeFontColor);
    text-align: left;
    margin-left: 10px;

    .subject {
      padding-right: 10px;
    }

    .pulseDivide {
      padding-right: 10px;
    }

    .textBold {
      font-weight: bold;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-style: italic;
    text-align: center;
    color: #c4c4c4;

    .viewDetailsBtn {
      .detailsBtn {
        background-color: transparent;
        color: var(--themeFontColor);

        &.is-disabled {
          opacity: 0.5;
        }
      }
    }

    .no-data {
      font-style: italic;
      color: #c4c4c4;
    }
  }
}
</style>

<style lang="scss">
.myMiniSurvey {
  .el-card__header {
    text-align: center;
    font-weight: bold;
  }

  &.mobile {
    .el-card__header {
      border-bottom: none;
    }
  }
}
</style>
